import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  box-shadow: 0px 0px 10px ${({ theme }) => theme.colors.primary.cetaceanBlue};
  display: flex;
  grid-area: headerRight;
  height: 100%;
  justify-content: space-between;
  padding: 18px 28px;
  width: 100%;

  ${media.greaterThan("medium")`
    margin-bottom: 30px;
    position: fixed;
    height: 72px;
    z-index: 10;
    width: calc(100vw - 248px);
    right: 0;
  `}
`;

export const Menu = styled.div`
  width: 24px;

  ${media.greaterThan("medium")`
    display: none;
  `}
`;

export const Logo = styled.img`
  max-height: 100%;
`;

export const Empty = styled.div`
  width: 36px;
`;

export const ProfileWidgetWrapper = styled.div`
  display: none;

  ${media.greaterThan("medium")`
    display: grid;
  `}
`;

export const CampaignSelectorWrapper = styled.div`
  ${media.greaterThan("medium")`
      display: none;
  `}
`;
